import React, { useState } from 'react';
import { BookModel } from '../../interfaces/book.interface';
import BookPage from '../../pages/BookPage/BookPage';
import FlipBook from '../../pages/BookFlip/BookFlip';
import AdminBookGrid from './AdminBookGrid';

interface AdminBooksTabProps {
  books: BookModel[];
  currentPage: number;
  totalBooksPages?: number;
  handleBooksPageChange: (page: string | number) => void;
  // Optional map of bookId -> number of book-print purchases. When provided, the grid shows it.
  purchaseCounts?: Record<string, number>;
  // Opt-in selection mode (admin bulk "mark as purchased").
  selectable?: boolean;
  selectedBookIds?: Set<string>;
  onToggleSelect?: (bookId: string) => void;
}

const AdminBooksTab: React.FC<AdminBooksTabProps> = ({
  books,
  currentPage,
  totalBooksPages,
  handleBooksPageChange,
  purchaseCounts,
  selectable,
  selectedBookIds,
  onToggleSelect,
}) => {
  const [showBookPage, setShowBookPage] = useState<string>('');
  const [showFlipBook, setShowFlipBook] = useState<string>('');

  if (showBookPage) {
    return (
      <div>
        <button
          className="flex items-center gap-1 text-sm text-storyblue hover:underline mb-4"
          onClick={() => setShowBookPage('')}
        >
          ← Back to books
        </button>
        <BookPage bookIdAdmin={showBookPage} />
      </div>
    );
  }

  if (showFlipBook) {
    return (
      <div>
        <button
          className="flex items-center gap-1 text-sm text-storyblue hover:underline mb-4"
          onClick={() => setShowFlipBook('')}
        >
          ← Back to books
        </button>
        <FlipBook bookIdAdmin={showFlipBook} />
      </div>
    );
  }

  if (!books || books.length === 0) {
    return <div className="text-center text-gray-500 py-8">No books found for this user.</div>;
  }

  return (
    <AdminBookGrid
      books={books}
      totalBooksPages={totalBooksPages}
      currentPage={currentPage}
      handleBooksPageChange={handleBooksPageChange}
      onOpenBookPage={setShowBookPage}
      onOpenFlipBook={setShowFlipBook}
      purchaseCounts={purchaseCounts}
      selectable={selectable}
      selectedBookIds={selectedBookIds}
      onToggleSelect={onToggleSelect}
    />
  );
};

export default AdminBooksTab;
